import { CenterGroup } from '../../../lib/types/models/center-group/center-group'
import { CenterGroupInput } from '../../../lib/types/models/center-group/center-group-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function createCenterGroup(centerId: number, input: CenterGroupInput) {
  return restApiClient
    .url(constructApiUrl(API.centers.createCenterGroup.url, { id: centerId }))
    .post<CenterGroup, CenterGroupInput>(input)
}
